__turbopack_context__.v({
  "count": "Contributors-module__LKfkNG__count",
  "panel": "Contributors-module__LKfkNG__panel",
});
